// extracted by mini-css-extract-plugin
export default {"finalText":"FinalText_finalText__lqcI3","won":"FinalText_won__xf4jw","lost":"FinalText_lost__gcYXd","tie":"FinalText_tie__6X780"};